var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8801 3.2356C14.9967 4.42724 13.4775 6.11061 12.4868 8.10386L12.2643 8.55161L12.712 8.77415L15.0607 9.94148L15.5085 10.164L15.731 9.71627C17.1824 6.79601 20.1046 4.98417 23.3617 4.98417C28.0569 4.98417 31.8775 8.80476 31.8775 13.5C31.8775 18.1951 28.0569 22.0157 23.3617 22.0157C20.1046 22.0157 17.1824 20.2039 15.731 17.2836L15.5085 16.8359L15.0607 17.0584L12.712 18.2258L12.2643 18.4483L12.4868 18.896C13.4775 20.8892 14.9967 22.5727 16.8801 23.7643C18.8181 24.9906 21.0598 25.6386 23.3617 25.6386C30.0554 25.6386 35.5003 20.1937 35.5003 13.5C35.5003 6.80635 30.0554 1.36133 23.3617 1.36133C21.0598 1.36133 18.8181 2.0093 16.8801 3.2356ZM16.8801 3.2356L17.1474 3.65812L16.8801 3.2356Z",
    fill: "#402C0D",
    stroke: "#A8824F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3614 15.3115H23.8614V14.8115V12.1887V11.6887H23.3614H8.22769L9.06962 10.8468L9.42318 10.4932L9.06962 10.1397L7.21499 8.28511L6.86143 7.93157L6.50789 8.28512L1.64644 13.1466L1.29289 13.5002L1.64645 13.8537L6.50796 18.7151L6.86152 19.0687L7.21507 18.7151L9.06956 16.8605L9.42311 16.507L9.06956 16.1534L8.22762 15.3115H23.3614Z",
    fill: "#402C0D",
    stroke: "#A8824F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.358f0019.svg";
export { ForwardRef as ReactComponent };